module.exports = __webpack_public_path__ + "static/media/Get-Top-Dollar-for-Your-Ride.863eceea.jpg";